import * as React from "react";
import { SVGProps } from "react";

const StatusErrorSVG: React.FC<SVGProps<SVGSVGElement>> = (props: SVGProps<SVGSVGElement>) => (
  <svg data-testid="status-error-icon" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m8 14.071 7.071-7.07" stroke="#fff" strokeWidth={2.5} strokeLinecap="round" />
    <path d="M7.651 14.267 4 11" stroke="#fff" strokeWidth={2} strokeLinecap="round" />
    <path
      d="M9.5 0A9.5 9.5 0 1 0 19 9.5 9.51 9.51 0 0 0 9.5 0Z"
      fill="#CF2A2A"
      style={{
        stroke: "none",
      }}
    />
    <path
      style={{
        color: "#000",
        fill: "#fff",
        strokeLinecap: "round",
      }}
      d="M12.86 4.953a1.188 1.188 0 0 0-.84.348L9.5 7.822l-2.52-2.52a1.188 1.188 0 0 0-1.677 0 1.188 1.188 0 0 0 0 1.678l2.52 2.52-2.52 2.52a1.188 1.188 0 0 0 0 1.677 1.188 1.188 0 0 0 1.677 0l2.52-2.52 2.52 2.522a1.188 1.188 0 0 0 1.68 0 1.188 1.188 0 0 0 0-1.68L11.18 9.5l2.52-2.52a1.188 1.188 0 0 0 0-1.68 1.188 1.188 0 0 0-.84-.347z"
    />
  </svg>
);

export default StatusErrorSVG;
